module.exports = "/fonts/fa-regular-400.svg?89ffa3aba80d30ee0a9371b25c968bbb";